<template>
    <v-expansion-panels>
        <v-expansion-panel
            :key="index"
            v-for="(category, index) in categorizedModules"
        >
            <v-expansion-panel-header>{{ category.categoryName }}</v-expansion-panel-header>
            <v-expansion-panel-content
                class="py-6"
                color="grey lighten-5"
            >
                <v-container>
                    <v-row>
                        <div
                            style="text-align:center;margin: auto;width: 50%;padding: 15% 0;"
                            v-if="!category.trainingModules.length"
                        >
                            <h2>-- EMPTY --</h2>
                        </div>
                        <v-col
                            :key="training.moduleId"
                            cols="12"
                            md="4"
                            sm="6"
                            v-else
                            v-for="training in category.trainingModules"
                        >
                            <moduleItem :module="training" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    import moduleItem from './moduleItem.vue'

    export default {

        name: 'ModuleList',
        components: {
            moduleItem
        },
        props: ['modules'],
        computed: {
            categorizedModules() {
                return this.modules;
            }
        }
    }
</script>

<style scoped>

</style>